module.exports = __webpack_public_path__ + "media/images/loading-886a388f530f64c747608db10f9b5f50.svg";